type Props = {
  svgProps?: React.SVGProps<SVGSVGElement>
  iconColor?: string
}

export const ShareIcon = ({ svgProps, iconColor }: Props) => {
  return (
    <svg
      width={svgProps?.width ?? 16}
      height={svgProps?.height ?? 16}
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M19 11C19 9.61929 20.1193 8.5 21.5 8.5C22.8807 8.5 24 9.61929 24 11C24 12.3807 22.8807 13.5 21.5 13.5C20.7411 13.5 20.0611 13.1618 19.6026 12.6279L12.885 15.7482C12.9597 15.9855 13 16.238 13 16.5C13 16.762 12.9597 17.0145 12.885 17.2518L19.6026 20.3721C20.0611 19.8382 20.7411 19.5 21.5 19.5C22.8807 19.5 24 20.6193 24 22C24 23.3807 22.8807 24.5 21.5 24.5C20.1193 24.5 19 23.3807 19 22C19 21.738 19.0403 21.4855 19.115 21.2482L12.3974 18.1279C11.9389 18.6618 11.2589 19 10.5 19C9.11929 19 8 17.8807 8 16.5C8 15.1193 9.11929 14 10.5 14C11.2589 14 11.9389 14.3382 12.3974 14.8721L19.115 11.7518C19.0403 11.5145 19 11.262 19 11Z"
        fill={iconColor || '#131313'}
      />
    </svg>
  )
}
